export const FETCH_AP_INCOICE_REQUEST = 'FETCH_AP_INCOICE_REQUEST';
export const FETCH_AP_INCOICE_SUCCESS = 'FETCH_AP_INCOICE_SUCCESS'

export const FETCH_AP_INCOICE_VIEW_REQUEST = 'FETCH_AP_INCOICE_VIEW_REQUEST';
export const FETCH_AP_INCOICE_VIEW_SUCCESS = 'FETCH_AP_INCOICE_VIEW_SUCCESS';